// import FormGroup from "app/Components/Form/FormGroup.component";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import InputError from "app/Components/_form/InputError/InputError";
import React from "react";
import { Col, Row, FormGroup } from "react-bootstrap";
import { employeeFormLabel, employeeTrainingEligibilityList } from "../Constant";
import Label from "app/Components/_form/Label/Label";
import { useTraining } from "app/_helpers/hooks";
import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";

function TrainingForm({
  form = {},
  onChange,
  error = {},
  initialForm = {},
  effectiveDateFlag = false,
}) {
  const [, trainingOption] = useTraining("filter[type]=training");

  return (
    <Row>
      <Col md={4}>
        <FormGroup>
          <Label>{employeeFormLabel["trainingDesignation"]}</Label>

          <SimpleSelect
            name={"trainingDesignation"}
            value={+form?.trainingDesignation}
            onChange={onChange}
            options={trainingOption}
            // label={"name"}
            // id="value"
            placeHolder={employeeFormLabel["trainingDesignation"]}
          />
          <InputError error={error["trainingDesignation"]} />
        </FormGroup>
      </Col>
      <Col md={4}>
        <FormGroup>
          <Label>{employeeFormLabel["trainingEligibility"]}</Label>

          <SimpleSelect
            name={"trainingEligibility"}
            value={form.trainingEligibility}
            options={employeeTrainingEligibilityList}
            onChange={onChange}
            placeHolder={employeeFormLabel["trainingEligibility"]}
            label={"name"}
            id="value"
            disabled={!form.trainingDesignation}
          />
          <InputError error={error["trainingEligibility"]} />
        </FormGroup>
      </Col>
      {effectiveDateFlag && (
        <Col md={4}>
          <FormGroup>
            <Label>{employeeFormLabel["effectiveDate"]}</Label>

            <DatePicker
              name={"effectiveDate"}
              value={form.effectiveDate}
              onChangeDate={onChange}
              label={employeeFormLabel["effectiveDate"]}
              placeHolder={employeeFormLabel["effectiveDate"]}
              error={error["effectiveDate"]}
            />
            <InputError error={error["effectiveDate"]} />
          </FormGroup>
        </Col>
      )}
    </Row>
  );
}

export default TrainingForm;
